import React from "react";
import { useFormContext } from "react-hook-form";
import InputBox from "./InputBox";
import "../styles/filedelement.scss";

const TextInput = (props) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const { name, placeholder, label, className } = props;
  return (
    <InputBox name={name} label={label} errors={errors}>
      <input
        id={name}
        type={"text"}
        className={className}
        placeholder={placeholder}
        {...props}
        {...register(name, { valueAsNumber: props.type === "number" })}
      />
    </InputBox>
  );
};

export default TextInput;
